import React from "react";
import { CCard, CCardBody, CCol, CRow } from "@coreui/react";
import CIcon from "@coreui/icons-react";

const StatCardWithChart = ({ data, onCardClick }) => {
  return (
    <CRow className="mb-4">
      {data?.map((item, index) => (
        <CCol key={index} sm={6} lg={3} className="mb-3" >
          <CCard style={{ cursor: "pointer" }}
            onClick={() => onCardClick(item.key)} className="shadow-sm border-0">
            <CCardBody
              className={`text-center bg-${item.color}-subtle rounded-3 py-4`}
            >
              <div className="mb-3">
                <CIcon
                  icon={item.icon}
                  size="xxl"
                  className={`text-${item.color}`}
                />
              </div>
              <h5 className="fw-semibold mb-1">{item.title}</h5>
              <div className="fs-4 fw-bold">{item.value}</div>
            </CCardBody>
          </CCard>
        </CCol>
      ))}
    </CRow>
  );
};

export default StatCardWithChart;
